<template>
  <router-link
    class="no-underline cursor-pointer transition-all"
    :class="[themes[theme], sizes[size]]"
    :href="href"
    :to="to"
    :disabled="disabled"
    @click="$emit('click', $event)"
    active-class="active opacity-100 border-red"
    exact
  >
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  name: "sp-link",
  data() {
    return {
      themes: {
        default: "text-sm",
        primary: "text-blue",
        secondary: "text-secondary",
        nav: "block py-3 md:py-3 align-middle md:whitespace-no-wrap opacity-40 border-b-4 md:border-b-0 md:border-l-7 transition-opacity hover:opacity-100 hover:border-red min-h-sm",
        success: "border rounded text-xs text-green border-green hover:text-white hover:bg-green",
        grey: "border rounded text-xs text-grey border-grey hover:text-white hover:bg-grey",
        warning: "text-red",
        danger: "text-danger",
        blue: "text-white font-normal rounded focus:outline-none focus:shadow-outline border border-blue bg-blue shadow-lg hover:bg-white hover:text-blue mx-3"
      },

      sizes: {
        none: "",
        normal: "p-4",
        small: "p-3",
        xsmall: "px-3 py-1 mx-2",
        large: "p-8"
      }
    };
  },

  props: {
    type: {
      required: false,
      type: String,
      default: "javascript:"
    },

    to: {
      required: false,
      type: String | Object
    },

    href: {
      required: false,
      type: String
    },
    theme: {
      required: false,
      type: String,
      default: "default"
    },

    size: {
      required: false,
      type: String,
      default: "none"
    },

    disabled: {
      required: false,
      type: Boolean,
      default: false
    }
  }
};
</script>
